import { BlogPosts } from './BlogPosts';

export { useBlogPostsRendered } from './hooks';

export default BlogPosts;
